/* Coty Optique — suggestions automatiques de recherche (API Shopify « search/suggest ») */
(() => {
  'use strict';
  if (window.__cotyPS) return; window.__cotyPS = true;

  const lang = (document.documentElement.lang || 'fr').slice(0, 2);
  const T = {
    fr: { products: 'Modèles', queries: 'Suggestions', all: 'Voir tous les résultats', none: 'Aucun modèle trouvé', from: 'À partir de' },
    en: { products: 'Frames', queries: 'Suggestions', all: 'See all results', none: 'No frames found', from: 'From' },
    de: { products: 'Modelle', queries: 'Vorschläge', all: 'Alle Ergebnisse ansehen', none: 'Kein Modell gefunden', from: 'Ab' },
    es: { products: 'Modelos', queries: 'Sugerencias', all: 'Ver todos los resultados', none: 'Ningún modelo encontrado', from: 'Desde' },
    it: { products: 'Modelli', queries: 'Suggerimenti', all: 'Vedi tutti i risultati', none: 'Nessun modello trovato', from: 'A partire da' }
  }[lang] || null;
  const t = T || { products: 'Modèles', queries: 'Suggestions', all: 'Voir tous les résultats', none: 'Aucun modèle trouvé', from: 'À partir de' };
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const money = v => { const n = parseFloat(v); return isNaN(n) ? '' : '€' + n.toFixed(2).replace('.', ','); };
  const shortTitle = (title, vendor) => {
    const i = vendor ? title.toLowerCase().indexOf(vendor.toLowerCase()) : -1;
    const s = i >= 0 ? title.slice(i + vendor.length).trim() : title;
    return s || title;
  };
  const img = (u, w) => { if (!u) return ''; try { const x = new URL(u, location.href); x.searchParams.set('width', w); return x.toString(); } catch (e) { return u; } };

  function attach(form) {
    if (form.dataset.psReady) return; form.dataset.psReady = '1';
    const input = form.querySelector('input[name="q"]'); if (!input) return;
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('role', 'combobox'); input.setAttribute('aria-autocomplete', 'list'); input.setAttribute('aria-expanded', 'false');
    if (!form.querySelector('input[name="options[prefix]"]')) { const h = document.createElement('input'); h.type = 'hidden'; h.name = 'options[prefix]'; h.value = 'last'; form.appendChild(h); }
    form.classList.add('ps-host');
    const panel = document.createElement('div'); panel.className = 'ps'; panel.hidden = true; panel.id = 'ps-' + Math.random().toString(36).slice(2, 8);
    panel.setAttribute('role', 'listbox'); input.setAttribute('aria-controls', panel.id);
    form.appendChild(panel);

    let timer = 0, ctrl = null, last = '', active = -1;
    const links = () => [...panel.querySelectorAll('[data-ps-opt]')];
    const close = () => { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); active = -1; };
    const open = () => { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); };
    const fullUrl = q => { const u = new URL(form.getAttribute('action') || root + 'search', location.href); new FormData(form).forEach((v, k) => u.searchParams.set(k, v)); u.searchParams.set('q', q); return u.pathname + u.search; };

    const render = (q, data) => {
      const res = (data && data.resources && data.resources.results) || {};
      const prods = (res.products || []).slice(0, 6), queries = (res.queries || []).filter(x => x.text && x.text.toLowerCase() !== q.toLowerCase()).slice(0, 4);
      let h = '';
      if (queries.length) {
        h += '<div class="ps__group"><p class="ps__label">' + esc(t.queries) + '</p><div class="ps__queries">';
        queries.forEach(x => { h += '<a class="ps__query" data-ps-opt href="' + esc(fullUrl(x.text)) + '">' + (x.styled_text || esc(x.text)) + '</a>'; });
        h += '</div></div>';
      }
      h += '<div class="ps__group"><p class="ps__label">' + esc(t.products) + '</p>';
      if (prods.length) {
        h += '<ul class="ps__list" role="list">';
        prods.forEach(p => {
          const pic = p.featured_image && p.featured_image.url || p.image;
          h += '<li><a class="ps__item" data-ps-opt href="' + esc(p.url) + '">' +
            '<span class="ps__img">' + (pic ? '<img src="' + esc(img(pic, 240)) + '" alt="" loading="lazy">' : '') + '</span>' +
            '<span class="ps__txt"><span class="ps__vendor">' + esc(p.vendor) + '</span><span class="ps__title">' + esc(shortTitle(p.title, p.vendor)) + '</span></span>' +
            '</a></li>';
        });
        h += '</ul>';
      } else h += '<p class="ps__none">' + esc(t.none) + '</p>';
      h += '</div><a class="ps__all" data-ps-opt href="' + esc(fullUrl(q)) + '">' + esc(t.all) + ' <span aria-hidden="true">→</span></a>';
      panel.innerHTML = h; active = -1; open();
    };

    const fetchFor = q => {
      if (ctrl) ctrl.abort(); ctrl = new AbortController();
      const u = root + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,query&resources[limit]=6&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,vendor,product_type,tag,variants.title';
      panel.classList.add('is-loading');
      fetch(u, { signal: ctrl.signal, headers: { Accept: 'application/json' } })
        .then(r => r.json()).then(d => { if (input.value.trim() === q) render(q, d); })
        .catch(() => {}).finally(() => panel.classList.remove('is-loading'));
    };

    input.addEventListener('input', () => {
      const q = input.value.trim(); clearTimeout(timer);
      if (q.length < 2) { last = ''; close(); return; }
      if (q === last) return; last = q;
      timer = setTimeout(() => fetchFor(q), 160);
    });
    input.addEventListener('focus', () => { if (panel.innerHTML && input.value.trim().length >= 2) open(); });
    input.addEventListener('keydown', e => {
      const ls = links();
      if (e.key === 'Escape') { close(); return; }
      if (panel.hidden || !ls.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault(); active = (active + (e.key === 'ArrowDown' ? 1 : -1) + ls.length) % ls.length;
        ls.forEach((a, i) => a.classList.toggle('is-active', i === active)); ls[active].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && active >= 0) { e.preventDefault(); location.href = ls[active].href; }
    });
    document.addEventListener('click', e => { if (!form.contains(e.target)) close(); });
  }

  const scan = () => document.querySelectorAll('form[role="search"]').forEach(attach);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();
